import firebase from 'firebase/app';
import { Platform } from 'react-native';

const firebaseConfig = {
  apiKey: 'AIzaSyChX5uEtwvPT3dtzJioO7SaI9slEr8arso',
  authDomain: 'zonetail-home.firebaseapp.com',
  projectId: 'zonetail-home',
  storageBucket: 'zonetail-home.appspot.com',
  messagingSenderId: '612214356838',
  appId: '1:612214356838:web:3bba4a33bb7cd0db29a6a7',
  measurementId: 'G-Y24RJHNQ9F',
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
} else {
  firebase.app();
}

async function trackScreen(screenName) {
  await firebase
    .analytics()
    .logEvent('screen_view', { screen_name: screenName });
}

async function trackProperty(unitid, userid, property) {
  // unitid and userid are not relavent to the web version
  // as such they just return 'web'
  await firebase.analytics().setUserProperties({
    property,
    unitid,
    userid,
  });
}

async function trackEvent() {
  await firebase.analytics().logEvent('eventname');
}

async function trackAdvertAction(
  action,
  advertName,
  advertCategory,
  id,
  advertCategoryId,
) {
  console.log(`track action: ${action}`);
  await firebase.analytics().logEvent('advert_action', {
    action,
    advert_name: advertName,
    advert_category: advertCategory,
    id,
    advert_category_id: advertCategoryId,
  });
}

/**
 * @param category {string}
 * @param id {string}
 */

function trackAdvertCategory(category, id) {
  const categoryItem = {
    item_list_id: id,
    item_list_name: category,
  };
  console.log('trackAdvertCategory', categoryItem);
  firebase.analytics().logEvent(category, { category_id: id, category });
}

/**
 * Tracks the advert category
 * @param id {string}
 * @param name {string}
 * @param categoryId {string}
 * @param categoryName {string}
 * @param advertiserId {string}
 * @param advertiserName {string}
 * @param campaignId {string}
 * @param campaignName {string}
 */

async function trackAdvertViewHandler(
  id,
  name,
  categoryId,
  categoryName,
  advertiserId,
  advertiserName,
  campaignId,
  campaignName,
) {
  const item = {
    item_id: id,
    item_name: name,
    item_category: categoryId,
    item_category2: advertiserName,
    item_category3: campaignName,
    item_list_id: categoryId,
    item_list_name: categoryName,
    item_brand: campaignId,
    quantity: 1,
    item_location_id: advertiserId,
  };
  // console.log('trackAdvertView', item);
  // await firebase.analytics().logEvent('Category View', {
  //   items: [item],
  // });
  if (Platform.OS !== 'web') {
    await firebase
      .analytics()
      .logViewItem({
        items: [item],
      })
      .catch(console.log);
  }

  await firebase.analytics().logEvent('advert_view', {
    id,
    name,
    category_id: categoryId,
    category_name: categoryName,
    advertiser_id: advertiserId,
    advertiser_name: advertiserName,
    campaign_id: campaignId,
    campaign_name: campaignName,
    items: [item],
  });
}

async function trackAdvertView(advert) {
  const advertiserId = advert.advertiser.id.toString();
  const advertiserName = advert.advertiser.name;
  const categoryName = advert.categories[0].title;
  const categoryId = advert.categories[0].id.toString();
  const campaignName = advert.campaign?.name;
  const campaignId = advert.campaign?.id.toString();
  const name = advert.headline;
  const id = advert.id.toString();
  trackAdvertViewHandler(
    id,
    name,
    categoryId,
    categoryName,
    advertiserId,
    advertiserName,
    campaignId,
    campaignName,
  );
}

/**
 *
 * @param {string} id
 * @param {string} name
 * @param {string} categoryId
 * @param {string} categoryName
 * @param {string} advertiserId
 * @param {string} advertiserName
 * @param {string} campaignId
 * @param {string} campaignName
 */
async function trackAdvertDetailView(
  id,
  name,
  categoryId,
  categoryName,
  advertiserId,
  advertiserName,
  campaignId,
  campaignName,
) {
  // debugger;
  if (id) {
    console.log('track advert detail');
    await firebase.analytics().logEvent('advert_detail_view', {
      id,
      name,
      category_id: categoryId,
      category_name: categoryName,
      advertiser_id: advertiserId,
      advertiser_name: advertiserName,
      campaign_id: campaignId,
      campaign_name: campaignName,
    });
    trackLongScreenView(name, categoryId, id);
  }
}

/**
 *
 * @param {string} title
 * @param {string} categoryId
 * @param {string} advertId
 */

async function trackLongScreenView(title, categoryId, advertId) {
  const screenName = `explore::${categoryId}::${advertId}::${title}`;
  console.log(`tracking long screen name: ${screenName}`);
  await firebase.analytics().logEvent('screen_view', {
    screen_name: screenName,
  });
}

const analyticsWrapper = {
  trackScreen,
  trackScreenView: trackScreen,
  trackProperty,
  trackAdvertAction,
  trackEvent,
  trackAdvertCategory,
  trackAdvertView,
  trackAdvertDetailView,
};

export default analyticsWrapper;
